import React, { FC } from 'react';

interface Props {
  text: string;
  url?: string;
  title?: string;
  className?: string;
  openInNewWindow?: boolean;
}

const BlockLinkBrand: FC<Props> = ({ text, url, children }) => {
  const createMarkup = () => {
    return { __html: `<span>${text}</span>` };
  };
  return (
    <>
      <div className="icon-link-block">
        <a href={url} className="icon-link icon-link--sup">
          <div className="icon icon-xlarge icon--brand">{children}</div>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={createMarkup()} />
        </a>
      </div>
    </>
  );
};

export default BlockLinkBrand;
